<template>
    <div>
        <breadCrumb 
            :icon="'fa-gifts'"
            :category="$t(`sideNav.navSalonReport`)"
            subCategory="Room"
            :subSubCategory="''">
        </breadCrumb>

        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Room" @click="addData(null)">
                <span class="fal fa-plus mr-2"></span>
                <span>Add Room</span>
            </button>
        </div>

        <div v-if="!addToggle">
            <ul v-show="false" class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in tabs" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul>

            <div class="px-3 px-sm-5 py-4">
                <div class="tab-content">
                    <roomList
                        ref="dataList"
                        :outlets="outlets"
                        class="tab-pane active"
                        :selectedTab="selectedTab"
                        @onOutletChange="onOutletChange"
                        @addData="addData"
                        @editData="editData">
                    </roomList>

                    <!-- :class="{'active': selectedTab == 'list' }" -->
                </div>
            </div>
        </div>

        <dataForm
            ref="dataForm"
            :staffs="staffs"
            :outlets="outlets"
            @onModalClose="onDataFormClose">
        </dataForm>

        <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import dataForm from './Room_Form'
import RoomList from './Room_List'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuReportRoom',
    components:{
        BreadCrumb,
        dataForm, 
        RoomList, 
    },
    data(){
        let tabs = this.$i18n.messages[this.$i18n.locale].tab.appointmentTabs2
        let selectedtab = tabs[1].id

        return{
            showSpinner: false,

            addToggle: false,
            tabs: tabs,
            selectedTab: selectedtab,

            memberLists: [], 
            outlets:[],
            staffs: [],
        }
    },
    watch:{
        selectedTab(value){
            if(value == "active" || value == "hidden"){
                this.$refs.memberList.filterMemberByView(value);
            }
        },
    },
    methods:{
        loadStaff() {
            this.showSpinner = true
            this.loadStaffImpl()
        },
        async loadStaffImpl() {
            const url = "https://staff.tunai.io/business/staff/"

            await this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
            .then((response) => {
                this.staffs = []

                for(let staff of response.data['staffs']) {
                    this.staffs.push(staff)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })
            .finally(() => {
                this.showSpinner = false
            })
        },

        onOutletChange(val) {
            this.filterOutlet = val
        },

        addData(date) {
            this.$refs.dataForm.show(this.filterOutlet, null, date)
        },
        editData(item) {
            let outlet = this.outlets.find(k => k['id'] === item['outletID'])
            this.$refs.dataForm.show(outlet, item)
        },
        onDataFormClose() {
            this.$refs.dataList.loadData()
        },
    },
    mounted(){
        this.outlets = JSON.parse(this.$store.state.outlets);
        this.outlets.unshift({ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) })
        this.filterOutlet = this.outlets[0];

        this.loadStaff()
    },
}
</script>